import React from "react";
import {
  Container,
  Message,
  Logo,
  ContainerMessage,
  LinkMessage,
} from "./style";
const NotFound = () => {
  return (
    <Container>
      <ContainerMessage>
        <Logo src="https://bonnadona-public.s3.amazonaws.com/assets/halcon_1.png" />
        <Message>Error no podemos encontrar la pagina</Message>
        <LinkMessage to="/">Ir Pagina principal</LinkMessage>
      </ContainerMessage>
    </Container>
  );
};

export default NotFound;
